var map = {
	"./accordion": [
		"./src/js/accordion.ts",
		7,
		[
			"accordion"
		]
	],
	"./accordion.ts": [
		"./src/js/accordion.ts",
		7,
		[
			"accordion"
		]
	],
	"./admin/main": [
		"./src/js/admin/main.ts",
		7,
		[
			"admin-main"
		]
	],
	"./admin/main.ts": [
		"./src/js/admin/main.ts",
		7,
		[
			"admin-main"
		]
	],
	"./core/types/JSModule": [
		"./src/js/core/types/JSModule.ts",
		9,
		[
			"core-types-JSModule"
		]
	],
	"./core/types/JSModule.ts": [
		"./src/js/core/types/JSModule.ts",
		9,
		[
			"core-types-JSModule"
		]
	],
	"./forms": [
		"./src/js/forms.ts",
		7,
		[
			"forms"
		]
	],
	"./forms.ts": [
		"./src/js/forms.ts",
		7,
		[
			"forms"
		]
	],
	"./gsap/text": [
		"./src/js/gsap/text.ts",
		9,
		[
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_CSSPlugin_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_gsap-core_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_index_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_Observer_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_ScrollTrigger_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_SplitText_js",
			"gsap-text"
		]
	],
	"./gsap/text.ts": [
		"./src/js/gsap/text.ts",
		9,
		[
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_CSSPlugin_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_gsap-core_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_index_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_Observer_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_ScrollTrigger_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_SplitText_js",
			"gsap-text"
		]
	],
	"./header": [
		"./src/js/header.ts",
		7,
		[
			"header"
		]
	],
	"./header.ts": [
		"./src/js/header.ts",
		7,
		[
			"header"
		]
	],
	"./key-numbers": [
		"./src/js/key-numbers.ts",
		7,
		[
			"key-numbers"
		]
	],
	"./key-numbers.ts": [
		"./src/js/key-numbers.ts",
		7,
		[
			"key-numbers"
		]
	],
	"./main": [
		"./src/js/main.ts",
		9,
		[]
	],
	"./main.ts": [
		"./src/js/main.ts",
		9,
		[]
	],
	"./matter/gravity": [
		"./src/js/matter/gravity.ts",
		9,
		[
			"vendors-node_modules_pnpm_matter-js_0_20_0_node_modules_matter-js_build_matter_js",
			"matter-gravity"
		]
	],
	"./matter/gravity.ts": [
		"./src/js/matter/gravity.ts",
		9,
		[
			"vendors-node_modules_pnpm_matter-js_0_20_0_node_modules_matter-js_build_matter_js",
			"matter-gravity"
		]
	],
	"./matter/init": [
		"./src/js/matter/init.ts",
		9,
		[
			"vendors-node_modules_pnpm_matter-js_0_20_0_node_modules_matter-js_build_matter_js",
			"matter-gravity",
			"matter-init"
		]
	],
	"./matter/init.ts": [
		"./src/js/matter/init.ts",
		9,
		[
			"vendors-node_modules_pnpm_matter-js_0_20_0_node_modules_matter-js_build_matter_js",
			"matter-gravity",
			"matter-init"
		]
	],
	"./slider": [
		"./src/js/slider.ts",
		9,
		[
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_CSSPlugin_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_gsap-core_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_index_js",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_a11y_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_autoplay_mjs-node_modules-9c273a",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_effect-cards_mjs-node_mod-ea60d7",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_free-mode_mjs-node_module-e82042",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_hash-navigation_mjs-node_-9babf5",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_index_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_manipulation_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_mousewheel_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_navigation_mjs-node_modul-152a5b",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_parallax_mjs-node_modules-07c166",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_virtual_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_zoom_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_shared_classes-to-selector_mjs-no-216d68",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_shared_swiper-core_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_shared_utils_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_swiper-element_mjs-node_modules_p-f2fe12",
			"slider"
		]
	],
	"./slider.ts": [
		"./src/js/slider.ts",
		9,
		[
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_CSSPlugin_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_gsap-core_js",
			"vendors-node_modules_pnpm_gsap_3_15_0_node_modules_gsap_index_js",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_a11y_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_autoplay_mjs-node_modules-9c273a",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_effect-cards_mjs-node_mod-ea60d7",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_free-mode_mjs-node_module-e82042",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_hash-navigation_mjs-node_-9babf5",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_index_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_manipulation_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_mousewheel_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_navigation_mjs-node_modul-152a5b",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_parallax_mjs-node_modules-07c166",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_virtual_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_modules_zoom_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_shared_classes-to-selector_mjs-no-216d68",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_shared_swiper-core_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_shared_utils_mjs",
			"vendors-node_modules_pnpm_swiper_14_0_6_node_modules_swiper_swiper-element_mjs-node_modules_p-f2fe12",
			"slider"
		]
	],
	"./tabs": [
		"./src/js/tabs.ts",
		7,
		[
			"tabs"
		]
	],
	"./tabs.ts": [
		"./src/js/tabs.ts",
		7,
		[
			"tabs"
		]
	],
	"./tooltip": [
		"./src/js/tooltip.ts",
		9,
		[
			"vendors-node_modules_pnpm_popperjs_core_2_11_8_node_modules_popperjs_core_lib_createPopper_js-b1e337",
			"vendors-node_modules_pnpm_popperjs_core_2_11_8_node_modules_popperjs_core_lib_popper_js",
			"vendors-node_modules_pnpm_popperjs_core_2_11_8_node_modules_popperjs_core_lib_utils_computeAu-0e1115",
			"vendors-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_tippy_esm_js",
			"tooltip"
		]
	],
	"./tooltip.ts": [
		"./src/js/tooltip.ts",
		9,
		[
			"vendors-node_modules_pnpm_popperjs_core_2_11_8_node_modules_popperjs_core_lib_createPopper_js-b1e337",
			"vendors-node_modules_pnpm_popperjs_core_2_11_8_node_modules_popperjs_core_lib_popper_js",
			"vendors-node_modules_pnpm_popperjs_core_2_11_8_node_modules_popperjs_core_lib_utils_computeAu-0e1115",
			"vendors-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_tippy_esm_js",
			"tooltip"
		]
	],
	"./utils/colors": [
		"./src/js/utils/colors.ts",
		9,
		[
			"utils-colors"
		]
	],
	"./utils/colors.ts": [
		"./src/js/utils/colors.ts",
		9,
		[
			"utils-colors"
		]
	],
	"./utils/screens": [
		"./src/js/utils/screens.ts",
		9,
		[]
	],
	"./utils/screens.ts": [
		"./src/js/utils/screens.ts",
		9,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[2].map(__webpack_require__.e)).then(function() { return __webpack_require__.t(id, ids[1] | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/js lazy recursive ^.*$";
module.exports = webpackAsyncContext;